import React from 'react';
import * as S from './styled';

const Loading = () => <S.Loading />;

export default Loading;
